import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=71226137&scoped=true"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71226137",
  null
  
)

export default component.exports